import React, { useRef } from 'react';
import { NavigationStepperItemType } from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import { useDisclose } from '../../../Modal/Hooks/useDisclose';
import CSSZSickLeaveCertificateCreateModal from '../CSSZSickLeaveCertificateCreate/CSSZSickLeaveCertificateCreateModal';
import CSSZSickLeaveCertificateList, {
	CSSZSickLeaveCertificateListHandle,
} from '../CSSZSickLeaveCertificateList/CSSZSickLeaveCertificateList';
import { useCsszSickLeaveUserQuery } from '../../../../graphql/graphql';
import { CSSZUser } from '../../Interfaces/CSSZ.interface';
import Loading from '../../../../Components/Loading';
import CSSZSickLeaveCertificateTakeoverModal from '../CSSZSickLeaveCertificateTakeover/CSSZSickLeaveCertificateTakeoverModal';

interface Props {
	patientId: string;
	workplaceId?: string;
}

const CSSZSickLeaveCertificateWrapper: React.FC<Props> = ({ patientId }) => {
	const initialActiveSickLeaveId = new URLSearchParams(
		window.location.search,
	).get('sickLeaveId');

	const {
		isOpen: isCreateOpen,
		onOpen: onCreateOpen,
		onClose: onCreateClose,
	} = useDisclose();
	const {
		isOpen: isTakeoverOpen,
		onOpen: onTakeoverOpen,
		onClose: onTakeoverClose,
	} = useDisclose();

	const CSSZSickLeaveCertificateListRef =
		useRef<CSSZSickLeaveCertificateListHandle>(null);

	const { data, isLoading } = useCsszSickLeaveUserQuery({ id: patientId });

	const handleOnCreateNew = async () => {
		onCreateClose();
		CSSZSickLeaveCertificateListRef.current?.refresh();
	};

	const handleOnTakeover = async () => {
		onTakeoverClose();
		CSSZSickLeaveCertificateListRef.current?.refresh();
	};

	if (isLoading) {
		return <Loading />;
	}

	if (!data) {
		return <></>;
	}

	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.CSSZSickLeaveCertificateWrapper.create',
			key: 'CSSZSickLeaveCertificateCreate',
			onClick: onCreateOpen,
		},
		{
			name: 'component.CSSZSickLeaveCertificateWrapper.takeover',
			key: 'CSSZSickLeaveCertificateTakeover',
			onClick: onTakeoverOpen,
		},
		{
			name: 'component.CSSZSickLeaveCertificateWrapper.list',
			key: 'CSSZSickLeaveCertificateList',
			component: () => (
				<CSSZSickLeaveCertificateList
					user={data.user as CSSZUser}
					initialActiveItemId={initialActiveSickLeaveId || undefined}
					ref={CSSZSickLeaveCertificateListRef}
				/>
			),
		},
	];

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='CSSZSickLeaveCertificateList'
				canSkip={true}
				showStepNumbers={false}
			/>
			{isCreateOpen && (
				<CSSZSickLeaveCertificateCreateModal
					onCreate={handleOnCreateNew}
					isOpen
					onClose={onCreateClose}
					user={data.user as CSSZUser}
				/>
			)}
			{isTakeoverOpen && (
				<CSSZSickLeaveCertificateTakeoverModal
					onSubmit={handleOnTakeover}
					isOpen
					onClose={onTakeoverClose}
					user={data.user as CSSZUser}
				/>
			)}
		</>
	);
};

export default CSSZSickLeaveCertificateWrapper;
